import React, { useEffect, useState } from 'react'
import { Card, CardBody, Label, FormGroup, Input, Container, Row, Col } from 'reactstrap';
import CustomButton from 'components/CustomButton';
import { putpost } from 'services/utils';
import { masterServiceBaseUrl } from 'services/http';
import { failureToast, successToast } from '../../../common/utils/methods/toasterFunctions/function';
import { regex } from 'views/pages/manage/common/constant';

const SapPlantMapping = (props) => {
    const { action, userPermissions, isViewOnly = false, formId, isNew = false, data } = props;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [apiloader, setApiLoader] = useState(false);

    const [value, setValue] = useState({
        sapPlantId: '',
        sapBusinessArea: '',
        sapDescription: '',
        businessPlaceCode: '',
        defermentBusinessArea: '',
        gstInNumber: ''
    })

    useEffect(() => {
        if (action === 'view' || action === 'edit') {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [action])

    const onKeyPress = (e) => {
        if (
            !regex.alphaNumeric.test(
                String.fromCharCode(e.charCode)
            )
        ) {
            e.preventDefault();
            return;
        }
    }

    useEffect(() => {
        setValue({
            sapPlantId: data?.sapPlantId ?? '',
            sapBusinessArea: data?.sapBusinessArea ?? '',
            sapDescription: data?.sapDescription ?? '',
            businessPlaceCode: data?.businessPlaceCode ?? '',
            defermentBusinessArea: data?.defermentBusinessArea ?? '',
            gstInNumber: data?.gstInNumber ?? ''
        })
    }, [data])

    const onUpdate = () => {
        if (value.sapPlantId === null || value.sapPlantId === ''){
            failureToast('Please Enter Sap plant ID');
            return
        }else if (value.sapPlantId && value.sapPlantId?.length < 4) {
            failureToast('Please Enter Valid Sap plant ID');
            return
        } else if (value.sapBusinessArea === null || value.sapBusinessArea === '') {
            failureToast('Please Enter Sap Bussiness Area');
            return
        } else if (value.sapBusinessArea && value.sapBusinessArea?.length < 4) {
            failureToast('Please Enter Valid Sap Bussiness Area');
            return
        } else if (value.sapDescription === null || value.sapDescription === '') {
            failureToast('Please Enter Description in SAP');
            return
        } else if (value.businessPlaceCode === null || value.businessPlaceCode === '') {
            failureToast('Please Enter Business place code');
            return
        } else if (value.businessPlaceCode && value.businessPlaceCode?.length < 4) {
            failureToast('Please Enter Valid Business place code');
            return
        } else if (value.defermentBusinessArea === null || value.defermentBusinessArea === '') {
            failureToast('Please Enter Deferment business area');
            return
        } else if (value.defermentBusinessArea && value.defermentBusinessArea?.length < 4) {
            failureToast('Please Enter Valid Deferment business area');
            return
        } else if (value.gstInNumber === null || value.gstInNumber === '') {
            failureToast('Please Enter GSTIN number');
            return
        } else if (value.gstInNumber && !value.gstInNumber.startsWith(value.stateCode.gstCode)) {
            failureToast('Please Enter Valid GSTIN number');
            return
        } else if (value.gstInNumber && value.gstInNumber?.length < 15) {
            failureToast('Please Enter Valid GSTIN number');
            return
        }
        setApiLoader(true);

        let obj = {
            ...data,
            ...value
        };

        putpost(
            masterServiceBaseUrl + '/businessArea/updateBusinessArea/' + formId,
            data => {
                successToast(data['message']);
                setApiLoader(false);
                setIsUpdated(false);
                setIsDisabled(true);
            },
            data => {
                setApiLoader(false);
                failureToast(data['message']);
            },
            obj,
            'put'
        );

    }

    return (
        <Container className={'mt-4'} fluid={true} >
            <Card className="mb-4">
                <CardBody>
                    <Row style={{ marginTop: '1.5rem ' }}>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example3cols2Input">
                                    *SAP Plant ID
                                </Label>
                                <Input
                                    value={value.sapPlantId}
                                    name="acadOrg"
                                    disabled={isDisabled}
                                    placeholder="Enter SAP plant ID"
                                    type="text"
                                    maxLength="6"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            sapPlantId: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                    onKeyPress={onKeyPress}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example3cols2Input">
                                    *SAP business area
                                </Label>
                                <Input
                                    value={value.sapBusinessArea}
                                    name="acadOrg"
                                    disabled={isDisabled}
                                    placeholder="Enter SAP business area"
                                    type="text"
                                    maxLength="6"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            sapBusinessArea: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                    onKeyPress={onKeyPress}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example3cols2Input">
                                    *Description in SAP
                                </Label>
                                <Input
                                    value={value.sapDescription}
                                    name="acadOrg"
                                    disabled={isDisabled}
                                    placeholder="Enter description in SAP"
                                    type="text"
                                    maxLength="10"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            sapDescription: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example3cols2Input">
                                    *Business place code
                                </Label>
                                <Input
                                    value={value.businessPlaceCode}
                                    name="acadOrg"
                                    disabled={isDisabled}
                                    placeholder="Enter Business place code"
                                    type="text"
                                    maxLength="6"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            businessPlaceCode: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                    onKeyPress={onKeyPress}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example3cols2Input">
                                    *Deferment business area
                                </Label>
                                <Input
                                    value={value.defermentBusinessArea}
                                    name="acadOrg"
                                    disabled={isDisabled}
                                    placeholder="Enter deferment business area"
                                    type="text"
                                    maxLength="6"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            defermentBusinessArea: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                    onKeyPress={onKeyPress}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="example2cols1Input">
                                    *GSTIN Number
                                </Label>
                                <Input
                                    value={value.gstInNumber}
                                    name="atrributeDesc"
                                    disabled={isDisabled}
                                    placeholder="Enter GSTIN number"
                                    type="text"
                                    maxLength="15"
                                    onChange={sData => {
                                        let x = sData.target.value;
                                        setValue({
                                            ...value,
                                            gstInNumber: x,
                                        });
                                    }}
                                    style={{ height: '39px' }}
                                    onKeyPress={onKeyPress}
                                />
                            </FormGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="12">
                            <Col>
                                {isUpdated ? (
                                    //for first prod deployment removing 'Save & Next' from button text and this should be changed 
                                    <CustomButton
                                        className={'floatRight mt-4'}
                                        content={action === 'edit' || action === 'view' ? 'Update' : 'Save'}
                                        permissionType={'C,U'}
                                        // icon={true}
                                        onClick={() => {
                                            onUpdate();
                                        }}
                                        permissionSet={userPermissions}
                                    />
                                ) : action === 'edit' ? (
                                    <CustomButton
                                        className={'floatRight mt-4'}
                                        content={'Enable Form'}
                                        permissionType={'U'}
                                        // icon={true}
                                        onClick={() => {
                                            setIsDisabled(false);
                                            setIsUpdated(true);
                                        }}
                                        permissionSet={userPermissions}
                                    />
                                ) : null}
                            </Col>
                        </Col>
                    </Row>

                </CardBody>
            </Card>
        </Container>
    )
}

export default SapPlantMapping;